/*
 * Created on TUE 27 April 2021
 *
 * Copyright (c) 2021 Flix
 */

// import Layout from '../layouts';
import Loadable from 'react-loadable';
import Loading from './loaderTest';
const HomeComponent = Loadable({
  loader: () => import('../layouts/HomeLayout'),
  loading: Loading,
});
const PageComponent = Loadable({
  loader: () => import('../layouts/PagesLayout'),
  loading: Loading,
});
const indexRoutes = [
  // home route after login
   //{ path: '/', component: Layout.Home },
  { path: '/home', component: HomeComponent },
  // routes prior to login (login, resetPassword) - need to put this last or will always match
  { path: '/', component: PageComponent }

];

export default indexRoutes; 